<template>
  <div ref="echarts" v-bind:style="styleObject" class="echart-box"></div>
</template>

<script>
export default {
  name: 'MiniCharts',
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    height: {
      type: String,
      default: '50px',
    },
    width: {
      type: String,
      default: '',
    },
    haveBg: {
      type: Boolean,
      default: true,
    },
    // klineColor: {
    //   type: String,
    //   default: '#878999',
    // },
    colorCls: {
      type: String,
      default: '',
    },
    lineWidth: {
      type: String,
      default: '2',
    },
  },
  data() {
    return {
      isshowLoading: true,
      myEcharts: {},
      klineColor: '#878999',
      echartsData: {},
    };
  },
  computed: {
    styleObject() {
      return { height: this.height, width: this.width };
    },
  },
  watch: {
    dataList(value) {
      this.echartsData = value;
      this.eachart();
      this.$forceUpdate();
    },
    colorCls() {
      this.init();
      this.eachart();
      this.$forceUpdate();
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initEachart();
    },
    initEachart() {
      let bg;
      if (this.haveBg) {
        let ecolor = 'rgba(135, 137, 153, 0.2)';
        let tcolor = 'rgba(135, 137, 153, 0)';
        if (this.colorCls === 'u-1-cl') {
          ecolor = 'rgba(81, 188, 134, 0.2)';
          tcolor = 'rgba(81, 188, 134, 0)';
        }
        if (this.colorCls === 'u-4-cl') {
          ecolor = 'rgba(243, 78, 95, 0.2)';
          tcolor = 'rgba(243, 78, 95, 0)';
        }
        bg = {
          normal: {
            color: new window.echarts.graphic.LinearGradient(
              0, 0, 0, 1,
              [
                { offset: 0, color: ecolor },
                { offset: 1, color: tcolor },
              ],
            ),
          },
        };
      }
      // 基于准备好的dom，初始化echarts实例
      this.myEcharts = window.echarts.init(this.$refs.echarts);
      // 绘制图表
      this.myEcharts.setOption({
        grid: {
          left: -10,
          bottom: 0,
          top: 0,
          right: -10,
        },
        xAxis: {
          show: false,
          type: 'category',
          min: 'dataMin',
          max: 'dataMax',
        },
        yAxis: {
          show: false,
          type: 'value',
          min: 'dataMin',
          max: 'dataMax',
        },
        series: [
          {
            data: [],
            type: 'line',
            symbol: 'none',
            lineStyle: {
              normal: {
                color: this.klineColor,
                width: 2,
              },
            },
            areaStyle: bg,
          },
        ],
      });
    },
    eachart() {
      if (this.colorCls === 'u-1-cl') {
        this.klineColor = '#51BC86';
      }
      if (this.colorCls === 'u-4-cl') {
        this.klineColor = '#F34E5F';
      }
      this.myEcharts.resize();
      this.myEcharts.setOption({
        series: [
          {
            data: this.echartsData,
            type: 'line',
            lineStyle: {
              normal: {
                color: this.klineColor,
                width: this.lineWidth,
              },
            },
          },
        ],
      });
    },
  },
};

</script>
